import searchResults from './searchResults.vue'
import searchBoxResourceArticles from "./searchBoxResourceArticles.vue";
import searchBoxCategoryYear from "./searchBoxCategoryYear.vue";
import searchBoxMediaLibrary from "./searchBoxMediaLibrary.vue";
import searchBoxTechnicalLibrary from "./searchBoxTechnicalLibrary.vue";
import searchBoxWhereToBuy from "./searchBoxWhereToBuy.vue";
import searchBoxWhereToRepair from "./searchBoxWhereToRepair.vue";
import searchBoxGlobal from "./searchBoxGlobal.vue";

if (!window.Vue) {
    window.Vue = require('vue');
}

export {
    searchResults,
    searchBoxResourceArticles,
    searchBoxCategoryYear,
    searchBoxMediaLibrary,
    searchBoxTechnicalLibrary,
    searchBoxWhereToBuy,
    searchBoxWhereToRepair,
    searchBoxGlobal
}


